import React, { ReactElement, useMemo } from 'react';
import { ALERT_STYLE_TYPE } from 'b2b-components/core/components/Alert';
import { useTranslate } from 'b2b-apps/core/i18n/hooks';
import { ContentAlert, ContentLoading } from 'b2b-apps/shop/common/components';
import VeryfyingImg from './assets/veryfying.png';
import VeryfyingImg2x from './assets/veryfying@2x.png';
import { Props } from './VerifyOrderContent.types';

export const VerifyOrderContent = ({
  createVerifyData: { isLoading, data, wasStarted, isLoaded, hasFailed },
  onModalClose,
}: Props): ReactElement => {
  const t = useTranslate();

  const hasErrors = useMemo((): boolean => {
    if (isLoading) {
      return true;
    }

    if (data) {
      return data.some((item) => item.errors && item.errors.length > 0);
    }

    return false;
  }, [isLoading, data]);

  return (
    <div>
      {wasStarted && isLoading && (
        <ContentLoading
          title={t('Verifying form...')}
          src={VeryfyingImg}
          srcSet={VeryfyingImg2x}
        />
      )}
      {isLoaded && hasErrors && (
        <ContentAlert
          text={{
            title: t('Verification complete'),
            content: t('Form contains errors - please review and verify again.'),
            closeLabel: t('Close'),
          }}
          onClose={onModalClose}
          alertType={ALERT_STYLE_TYPE.error}
        />
      )}
      {isLoaded && !hasErrors && (
        <ContentAlert
          text={{
            title: t('Verification complete'),
            content: t('List was processed successfully.'),
            closeLabel: t('Close'),
          }}
          onClose={onModalClose}
          alertType={ALERT_STYLE_TYPE.success}
        />
      )}
      {hasFailed && (
        <ContentAlert
          text={{
            title: t('Error'),
            content: t('An error occurred. Please try again'),
            closeLabel: t('Close'),
          }}
          onClose={onModalClose}
          alertType={ALERT_STYLE_TYPE.error}
        />
      )}
    </div>
  );
};
